import { Group, Stack, Text } from '@mantine/core';
import { IconForms } from '@tabler/icons-react';
import { ActionCard, BubbleBody, type WaRendererProps } from './primitives';

/** Outbound WhatsApp Flow ("form") invite — header / body / footer inside the
 *  bubble, with the CTA as its own card below, the way WhatsApp renders it. */
export function FlowMessage({ view, incoming }: WaRendererProps) {
  const flow = view.flow;
  return (
    <Stack gap={2}>
      {flow?.headerText && (
        <Text size="sm" fw={700} style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {flow.headerText}
        </Text>
      )}
      <BubbleBody>{view.body ?? flow?.formName ?? 'Form'}</BubbleBody>
      {flow?.footerText && (
        <Text
          size="xs"
          c={incoming ? 'dimmed' : 'rgba(255,255,255,0.7)'}
          style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
        >
          {flow.footerText}
        </Text>
      )}
    </Stack>
  );
}

/** Read-only record of the form button that was sent. */
export function FlowCard({ view }: WaRendererProps) {
  const flow = view.flow;
  if (!flow) return null;
  return (
    <ActionCard>
      <Group justify="center" gap={6} style={{ padding: '10px 14px' }}>
        <IconForms size={16} color="var(--mantine-color-blue-6)" />
        <Text size="sm" fw={500} c="var(--mantine-color-blue-6)">
          {flow.flowCta}
        </Text>
      </Group>
    </ActionCard>
  );
}
